import styles from './sell-your-vehicle-banner.module.scss'
import { constants } from '@/lib/constants'

export const SellYourVehicleBanner = ({
  isVans,
  page,
  position,
}: {
  isVans: boolean
  page: string
  position: string
}) => {
  return (
    <a
      className={styles.main}
      href={`${constants.sellYourVehicleUrl.dealPage}${
        isVans
          ? `/sell-my-van?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=${position}-${page}`
          : `/partner/leaseloco?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=${position}-${page}`
      }`}>
      <div className={styles.content}>
        <span className={styles.title}>Need to value your {isVans ? 'van' : 'car'}?</span>
        <span className={styles.text}>Get the best price from 5,000+ dealers</span>
      </div>
      <span className={styles.button}>Value your {isVans ? 'van' : 'car'}</span>
      <svg
        width="91"
        height="105"
        viewBox="0 0 91 105"
        fill="none"
        className={styles.vector}
        xmlns="http://www.w3.org/2000/svg">
        <g>
          <rect
            y="110.778"
            width="96"
            height="49"
            transform="rotate(-60 0 110.778)"
            fill="white"
          />
          <rect
            width="96"
            height="49"
            transform="matrix(-0.5 -0.866025 -0.866025 0.5 90.4352 52.1384)"
            fill="white"
          />
        </g>
      </svg>
    </a>
  )
}
